import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeePermits: [],
    employeePermitsCount: 0,
    employeePermit: {},
    employeePermitSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeePermits(state) {
      return state.employeePermits
    },
    getEmployeePermitsCount(state) {
      return state.employeePermitsCount
    },
    getEmployeePermit(state) {
      return state.employeePermit
    },
    getEmployeePermitSaveStatus(state) {
      return state.employeePermitSave
    },
  },
  mutations: {
    EMPLOYEE_PERMITS_LIST(state, data) {
      state.employeePermits = data
    },
    EMPLOYEE_PERMIT_VIEW(state, data) {
      state.employeePermit = data
    },
    EMPLOYEE_PERMITS_COUNT(state, data) {
      state.employeePermitsCount = data
    },
    EMPLOYEE_PERMIT_SAVE(state, data) {
      state.employeePermitSave = data
    },
  },
  actions: {
    employeePermitsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_permits', data)
        .then(response => {
          commit('EMPLOYEE_PERMITS_LIST', response.data.data)
          commit('EMPLOYEE_PERMITS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeePermitView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_permits.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_permits', data)
        .then(response => {
          commit('EMPLOYEE_PERMIT_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeePermitSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_permits/saveData', data)
        .then(response => {
          commit('EMPLOYEE_PERMIT_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
